import React from 'react'
import { t } from 'ttag'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { getTimer } from 'ducks/timer'
import styles from './ConfirmFinish.module.scss'
import { formatTimeVerbose } from 'utils/stringFormat'
import { BoldButton } from 'components/shared/BoldButton/BoldButton'

import { getGMA, finishGMA, submitGMA } from 'ducks/respondent'

type ContentProps = {
  totalAnswers?: number
  totalQuestions?: number
}

const Content = ({ totalAnswers, totalQuestions }: ContentProps) => {
  const { secondsLeft }: { secondsLeft?: number } = useSelector(getTimer)

  return (
    <div className={styles.paragraphs}>
      <div className={styles.paragraph}>
        {t`You have answered ${totalAnswers} of ${totalQuestions} questions`}.
      </div>
      <div className={styles.paragraph}>
        {t`You have `} {formatTimeVerbose(secondsLeft)}
        {t` left`}.
      </div>
    </div>
  )
}

const ConfirmFinish = () => {
  const { totalQuestions, totalAnswers } = useSelector(getGMA, shallowEqual)
  const dispatch = useDispatch()

  return (
    <div className={styles.background}>
      <div className={styles.container}>
        <div className={styles.title}>{t`Submit?`}</div>
        <Content totalAnswers={totalAnswers} totalQuestions={totalQuestions} />
        <div className={styles.buttons}>
          <BoldButton
            label={t`Yes, I'm done`}
            onClick={() => dispatch(finishGMA({ reason: 'click button' }))}
            isPrimary={false}
          />
          <BoldButton
            label={t`No, take me back`}
            onClick={() => dispatch(submitGMA())}
            isPrimary
          />
        </div>
      </div>
    </div>
  )
}

export default ConfirmFinish
